export default __webpack_public_path__ + "static/media/Header.80e88ff2.svg";